import React from 'react';
import {ToastContainer} from 'react-toastify';
import AppRoute from './Routes';

import './assets/bootstrap.min.css';
import './assets/metisMenu.min.css';
import './assets/app.min.css';

const App = () => (
    <>
        <AppRoute />
        <ToastContainer />
    </>
);

export default App;